import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert, PageHeader, Panel } from 'react-bootstrap';
import ProgressBar from "../../components/common/ProgressBar/ProgressBar";
import request from 'superagent';

export default class CalendarFeedSettings extends Component {
  static defaultProps = {
    connectionId: null,
  };

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    connectionId: PropTypes.number,
  };

  initialState = {
    loading: true,
    calendarSettings: null,
  };

  state = {...this.initialState};

  componentDidMount() {
    this.fetchCalendarFeedSettings();
  }

  fetchCalendarFeedSettings() {
    console.log(`Fetching calendar feed settings for ${this.props.connectionId}`);

    this.setState(this.initialState);

    request
      .get(`/rpc/integrations/connections/${this.props.connectionId}/calendar-settings`)
      .then(
        (res) => {
          this.setState({ loading: false, calendarSettings: res.body });
        },
        (errRes) => {
          this.setState({ loading: false });
        }
      );
  }

  render() {
    if (this.state.loading)
      return (<ProgressBar active now={100} />);

    const { calendarSettings } = this.state;

    return (
      <div className="calendar-feed-settings">
        <PageHeader>Calendar Feed Settings</PageHeader>

        <Alert bsStyle="info">
          Calendar Feeds only include bankruptcy courts. In addition, the following courts do not provide a calendar feed:

          <ul>
            <li>Maryland Bankruptcy Court</li>
            <li>Massachusetts Bankruptcy Court</li>
            <li>Pennsylvania Middle Bankruptcy Court</li>
            <li>Texas Southern Bankruptcy Court</li>
          </ul>
        </Alert>

        <p>Calendar feeds include events in the next 30 days.  You will be charged one integration call per event
          that is delivered to your calendar feed.
        </p>

        <Panel className="calendar-feed">
          <Panel.Heading><Panel.Title>My Cases Calendar Feed</Panel.Title></Panel.Heading>
          <Panel.Body>
            {calendarSettings.user_feed_url}
            <p>Use this address to access your cases calendar from other applications.  The calendar is in iCal format.</p>
          </Panel.Body>
        </Panel>

        <Panel className="calendar-feed">
          <Panel.Heading><Panel.Title>Firm Cases Calendar Feed</Panel.Title></Panel.Heading>
          <Panel.Body>
            {calendarSettings.firm_feed_url}
            <p>Use this address to access your firm cases calendar from other applications.  The calendar is in iCal format.</p>
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/CalendarFeedConfig.jsx